import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {EnumFiltroDePedidos, PedidosService} from "../../services/pedidos.service";
import {ActivatedRoute} from "@angular/router";
import {GridPedidosComponent} from "../grid-pedidos/grid-pedidos.component";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {RotaGuardClient} from "../../guards/auth-loja.guard";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {ImpressaoService} from "../../services/impressao.service";
import {Subscription} from "rxjs";

declare var moment;
declare var _;
@Component({
  selector: 'app-tela-pedidos-pagos',
  templateUrl: './tela-pedidos-pagos.component.html',
  styleUrls: ['./tela-pedidos-pagos.component.scss']
})
export class TelaPedidosPagosComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('gridPedidos', { static: false}) gridPedidos: GridPedidosComponent;
  pedidos: [];
  paginacao = { total: 1000};
  carregando: any = false;
  filtro: any = { inicio: null, fim: null};
  resumoPedidos: any = { qtde: 0, total: 0, totalTaxas: 0 };
  @Input() mesa = false;
  @Input() empresa: any = {};
  temModuloComissionamento = false;
  objFiltro: any = {
    q: '',
    pendenteComissionado: false,
    filtroImpressao: null
  };
  opcoesFiltroImpressao: any[] = [{id: 0, descricaoFiltro: 'Não impressos nunca'}];
  private inscricaoPedidoImpresso: Subscription;
  usuario = {};
  timerBusca: any;
  constructor(private autorizacaoService: AutorizacaoService,
              private pedidosService: PedidosService, private activatedRoute: ActivatedRoute,
              private constantsService: ConstantsService, private impressaoService: ImpressaoService) {

  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser();
    this.filtro.inicio = moment().add(-3, 'd').toDate();
    this.filtro.fim = new Date();
    this.constantsService.moduloComissionamento$.subscribe((ativo) => {
      this.temModuloComissionamento = !!ativo;
      if(!this.temModuloComissionamento && this.objFiltro.pendenteComissionado)
        this.objFiltro.pendenteComissionado = false;
    });

    this.inscricaoPedidoImpresso = this.impressaoService.onPedidoImpresso.subscribe((dados: any) => {
      const idImpressora = this.obtenhaIdImpressoraFiltro();
      if(this.objFiltro.filtroImpressao === 0 ||
        (idImpressora && Number(dados?.impressora?.id) === idImpressora))
        this.carreguePedidos();
    });

    this.carreguePedidos();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.empresa)
      this.atualizeOpcoesFiltroImpressao();
  }

  ngOnDestroy() {
    if(this.inscricaoPedidoImpresso)
      this.inscricaoPedidoImpresso.unsubscribe();
  }

  private atualizeOpcoesFiltroImpressao() {
    const impressoras = this.empresa?.configImpressao?.impressoras || [];
    this.opcoesFiltroImpressao = [
      {id: 0, descricaoFiltro: 'Não impressos nunca'},
      ...impressoras
      .filter((impressora: any) => impressora && !impressora.removida)
      .map((impressora: any) => ({
        id: impressora.id,
        descricaoFiltro: `Não impressos em "${impressora.setor || impressora.nome}"`
      }))
    ];
  }

  visualizaRelatorios(){
    return RotaGuardClient.visualizaRelatorios(this.usuario)
  }

  onFilter($event: Event) {
    if(this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout(() =>  {
      this. carreguePedidos();
    }, 1000)
  }


  carreguePedidos(){
    if(this.carregando) return;

    let dtInicio = moment(this.filtro.inicio).format('YYYYMMDD');
    let dtFim = moment(this.filtro.fim).format('YYYYMMDD');

    this.carregando = true;

    let filtro = EnumFiltroDePedidos.pedidos;
    if( this.mesa )
      filtro = EnumFiltroDePedidos.comanda;

    this.pedidosService.listePedidos(0, this.paginacao.total,
      {
        apenasEncerrados: true,
        dtInicio: dtInicio,
        dtFim: dtFim,
        q: this.objFiltro.q,
        pendenteComissionado: this.objFiltro.pendenteComissionado,
        idImpressoraSemImpressao: this.obtenhaIdImpressoraFiltro()
      }, filtro).then( (resposta) => {
      this.setPedidos(this.filtrePedidos(resposta.pedidos || []));
      this.gridPedidos.atualizeGridPedidos(this.pedidos, 'finalizados');
      this.carregando = false;
    }).catch( () => {
      this.carregando = false;
    });
  }

  private filtrePedidos(pedidos: any) {
    if(this.objFiltro.filtroImpressao === 0)
      return pedidos.filter((pedido: any) => !pedido.impresso);

    return pedidos;
  }

  private obtenhaIdImpressoraFiltro(): number {
    const idImpressora = Number(this.objFiltro.filtroImpressao);
    return Number.isInteger(idImpressora) && idImpressora > 0 ? idImpressora : null;
  }


  private setPedidos(resposta: any) {
    this.pedidos = resposta || [];
    this.resumoPedidos.qtde = this.pedidos.length;
    this.resumoPedidos.totalTaxas = _.reduce( this.pedidos, (valor, pedido) => valor + pedido.taxaEntrega, 0);
    this.resumoPedidos.total = _.reduce( this.pedidos, (valor, pedido) => valor + pedido.total, 0);

    this.resumoPedidos.total -=    this.resumoPedidos.totalTaxas;

  }
}
